import { ProposalProject } from "../Model/ProposalProject";

export class GetProposalProjectList {
    constructor(
        total,
        offset,
        limit,
        records
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
        return new GetProposalProjectList(
            data.total,
            data.offset,
            data.limit,
            data.records.map((record) =>{
                return ProposalProject.createFromResponseData(record);
            }),
        );
    }
};